import {Component, ElementRef, EventEmitter, HostListener, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-section',
  imports: [],
  templateUrl: './section.component.html',
  standalone: true,
  styleUrl: './section.component.scss'
})
export class SectionComponent {
  @ViewChild('section', { static: false }) private section!: ElementRef;
  @Output() borderEmit = new EventEmitter();

  height = 0;
  isVisible: boolean = true;
  @HostListener('window:scroll', ['$event'])
  textAppear(event: WheelEvent) {
    event.preventDefault();
    const rect = this.section?.nativeElement.getBoundingClientRect();
    const distanceToTop = rect.top;
    this.isVisible = distanceToTop <= window.innerHeight * 0.4;
    this.borderEmit.emit(this.isVisible);
  }
}
